module.exports = __webpack_public_path__ + "4370721c654fe60d78cc13e374a5024e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/crown-2.png
// module id = 2171
// module chunks = 0